/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * @author Gladson Samuel S
 * MultiRemediationComponentStyles.js
 * Styles for multi remediation component
 */

import { makeStyles } from '@material-ui/core';
import mixins from '../../../assets/styles/mixins.scss';

const useMultiRemediationComponentStyles = makeStyles({
  assetsContainer: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',

    '& *': {
      boxSizing: 'border-box'
    }
  },
  container: {
    '--card-height': '297px',
    '--card-max-width': '318px',

    [mixins['md-sm-min']]: {
      '--card-height': '300px',
      '--card-max-width': '334px'
    },
    [mixins['mlg-min']]: {
      '--card-height': '356px',
      '--card-max-width': '408px'
    },
    [mixins['3xl-min']]: {
      '--card-max-width': '390px'
    }
  },
  carouselContainer: {
    display: 'flex',
    flexDirection: 'column',
    '& .slick-list > .slick-track': {
      marginLeft: 0,
      gap: '12px',
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      flex: '0 1 var(--card-max-width)',
      maxWidth: 'var(--assetsContainer-width)',
      maxHeight: 'var(--card-height)'
    },
    '& .slick-list > .slick-track > .slick-slide': {
      display: 'flex',
      width: 'var(--assetsContainer-width) !important',
      maxWidth: 'var(--assetsContainer-width)'
    },
    '& .slick-list > .slick-track > .slick-slide > div': {
      width: '100%'
    },
    '& .slick-dots': {
      position: 'absolute',
      top: 'var(--slick-dots-position)',
      right: 0
    },
    '& .slider-arrow-left': {
      border: `1px solid ${mixins.darkBgBorder}`,
      top: 0,
      left: 'auto',
      '&:hover': {
        background: mixins.chalkWhiteFont
      }
    },
    '& .slider-arrow-right': {
      border: `1px solid ${mixins.darkBgBorder}`,
      top: 0,
      right: '0px',
      '&:hover': {
        background: mixins.chalkWhiteFont
      }
    }
  }
});

export default useMultiRemediationComponentStyles;
